// src/firebase/history.js
import {
  collection, serverTimestamp, query, orderBy, getDocs, addDoc
} from 'firebase/firestore';
import { db, auth } from './index';

/**
 * Save a completed game to the user's history.
 * gameData: { gameType, roomId, rank, totalPlayers, winner, opponents }
 */
export const saveGameHistory = async (uid, gameData) => {
  if (!uid) return;
  // Anonymous users don't get game history saved (Firestore rules also block it)
  if (auth.currentUser?.isAnonymous) return;
  if (!auth.currentUser || auth.currentUser.uid !== uid) {
    throw new Error('Could not save game history: the signed-in user changed.');
  }
  const opponents = gameData.opponents || (gameData.rankedPlayers || [])
    .filter(player => !player.isMe)
    .map(player => player.name)
    .filter(Boolean);
  await addDoc(collection(db, 'users', uid, 'gameHistory'), {
    ...gameData,
    opponents,
    playedAt: serverTimestamp(),
  });
};

/**
 * Fetch a user's completed games, newest first.
 */
export const getUserGameHistory = async (uid) => {
  if (!uid) return [];
  const q = query(
    collection(db, 'users', uid, 'gameHistory'),
    orderBy('playedAt', 'desc')
  );
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};
